export default {
  locale: "en",
  name: "Clients",
  translation: { displayName: "Translations" },
  fields: {
    list: [],
    form: [],
  },
};
